<template>
  <div>
    <a-form @submit="handleSubmit" :form="form" class="form">
      <a-card title="企业信息" class="card" :bordered="true">
        <a-button
          slot="extra"
          size="small"
          :loading="isSubmit"
          v-if="isEdit"
          type="primary"
          @click="handleSubmit">
          提交
        </a-button>
        <a-button slot="extra" size="small" v-if="isEdit" @click="isEdit = false" style="margin-left:15px;">取消</a-button>
        <a-button slot="extra" size="small" v-if="!isEdit" @click="isEdit = true" type="primary">编辑</a-button>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 12}" :lg="{span: 12}" :md="{span: 24}" :sm="24">
            <!-- 企业全称 -->
            <a-row class="form-row" :gutter="16">
              <a-col :xl="{span: 24}" :lg="{span: 24}" :md="{span: 24}" :sm="24">
                <a-form-item
                  label="企业全称"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <a-input v-show="isEdit" v-decorator="['system_name',{rules: [{ required: true, message: '请输入企业全称' }], validateTrigger: 'change'}]"/>
                  <span v-if="!isEdit">{{ data.system_name }}</span>
                </a-form-item>
              </a-col>
            </a-row>
            <!-- 企业简称 -->
            <a-row class="form-row" :gutter="16">
              <a-col :xl="{span: 24}" :lg="{span: 24}" :md="{span: 24}" :sm="24">
                <a-form-item
                  label="企业简称"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <a-input v-show="isEdit" v-decorator="['system_short_name',{rules: [{ required: true, message: '请输入企业简称' }], validateTrigger: 'change'}]"/>
                  <span v-if="!isEdit">{{ data.system_short_name }}</span>
                </a-form-item>
              </a-col>
            </a-row>
            <!-- 官网地址 -->
            <a-row class="form-row" :gutter="16">
              <a-col :xl="{span: 24}" :lg="{span: 24}" :md="{span: 24}" :sm="24">
                <a-form-item
                  label="官网地址"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <a-input v-show="isEdit" v-decorator="['system_url',{rules: [{ required: true, message: '请输入官网地址' }], validateTrigger: 'change'}]"/>
                  <span v-if="!isEdit">{{ data.system_url }}</span>
                </a-form-item>
              </a-col>
            </a-row>
            <!-- 联系QQ -->
            <a-row class="form-row" :gutter="16">
              <a-col :xl="{span: 24}" :lg="{span: 24}" :md="{span: 24}" :sm="24">
                <a-form-item
                  label="联系QQ"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <a-input v-show="isEdit" v-decorator="['qq_number',{rules: [{ required: true, message: '请输入联系QQ' }], validateTrigger: 'change'}]"/>
                  <span v-if="!isEdit">{{ data.qq_number }}</span>
                </a-form-item>
              </a-col>
            </a-row>
            <!-- 联系邮箱 -->
            <a-row class="form-row" :gutter="16">
              <a-col :xl="{span: 24}" :lg="{span: 24}" :md="{span: 24}" :sm="24">
                <a-form-item
                  label="联系邮箱"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <a-input v-show="isEdit" v-decorator="['email',{rules: [{ required: true, message: '请输入联系邮箱' }], validateTrigger: 'change'}]"/>
                  <span v-if="!isEdit">{{ data.email }}</span>
                </a-form-item>
              </a-col>
            </a-row>
            <!-- 联系电话 -->
            <a-row class="form-row" :gutter="16">
              <a-col :xl="{span: 24}" :lg="{span: 24}" :md="{span: 24}" :sm="24">
                <a-form-item
                  label="联系电话"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <a-input v-show="isEdit" v-decorator="['phone',{rules: [{ required: true, message: '请输入联系电话电话' }], validateTrigger: 'change'}]"/>
                  <span v-if="!isEdit">{{ data.phone }}</span>
                </a-form-item>
              </a-col>
            </a-row>
            <!-- 联系地址 -->
            <a-row class="form-row" :gutter="16">
              <a-col :xl="{span: 24}" :lg="{span: 24}" :md="{span: 24}" :sm="24">
                <a-form-item
                  label="联系地址"
                  :labelCol="{lg: {span: 6}, sm: {span: 6}}"
                  :wrapperCol="{lg: {span: 18}, sm: {span: 18} }">
                  <a-input v-show="isEdit" v-decorator="['address',{rules: [{ required: true, message: '请输入联系地址' }], validateTrigger: 'change'}]"/>
                  <span v-if="!isEdit">{{ data.address }}</span>
                </a-form-item>
              </a-col>
            </a-row>
          </a-col>
          <a-col :xl="{span: 12}" :lg="{span: 12}" :md="{span: 24}" :sm="24">
            <a-row class="form-row" :gutter="16">
              <a-col :xl="{span: 24}" :lg="{span: 24}" :md="{span: 24}" :sm="24">
                <a-form-item
                  label="企业LOGO"
                  :labelCol="{lg: {span: 10}, sm: {span: 10}}"
                  :wrapperCol="{lg: {span: 14}, sm: {span: 14} }">
                  <img v-if="!isEdit" :src="logoUrl" style="width:160px;border:1px solid #ccc;" alt="LOGO"/>
                  <a-upload
                    v-if="isEdit"
                    name="file"
                    :defaultFileList="fileList"
                    listType="picture-card"
                    class="avatar-uploader"
                    :showUploadList="false"
                    action="/merchant.php/upload_file/uploadFile?type=system&local=YES"
                    @change="handleChange"
                  >
                    <img v-if="logoUrl" :src="logoUrl" style="width:150px;" alt="LOGO" />
                    <div v-else>
                      <a-icon :type="loading ? 'loading' : 'plus'" />
                      <div class="ant-upload-text">上传</div>
                    </div>
                  </a-upload>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row style="display:none" class="form-row" :gutter="16">
              <a-col :xl="{span: 24}" :lg="{span: 24}" :md="{span: 24}" :sm="24">
                <a-form-item
                  label="APP下载地址"
                  :labelCol="{lg: {span: 10}, sm: {span: 10}}"
                  :wrapperCol="{lg: {span: 14}, sm: {span: 14} }">
                  <p style="font-size:15px;">{{ data.app_download_url }}</p>
                  <img :src="downloadUrl" style="width:160px;border:1px solid #ccc;" alt="code"/>
                  <!-- <a-upload
                    v-if="isEdit"
                    name="file"
                    :defaultFileList="downloadList"
                    listType="picture-card"
                    class="avatar-uploader"
                    :showUploadList="false"
                    action="/merchant.php/upload_file/uploadFile?type=system"
                    @change="handleDownloadChange"
                  >
                    <img v-if="downloadUrl" :src="downloadUrl" style="width:150px;" alt="code" />
                    <div v-else>
                      <a-icon :type="loading ? 'loading' : 'plus'" />
                      <div class="ant-upload-text">上传</div>
                    </div>
                  </a-upload> -->
                </a-form-item>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-card>
    </a-form>
  </div>
</template>
<script>
import _ from 'lodash'
import { getPre, saveConfig } from '@/api/system'
import { mixin, mixinDevice } from '@/utils/mixin'
// import { buildFile } from '@/utils/util'
import notification from 'ant-design-vue/es/notification'
export default {
  mixins: [mixin, mixinDevice],
  components: {
  },
  created () {
    this.handlePre()
  },
  data () {
    return {
      loading: false,
      isEdit: false,
      isSubmit: false,
      form: this.$form.createForm(this),
      data: {},
      fileList: [],
      downloadList: [],
      downloadUrl: '',
      logoUrl: ''
    }
  },
  methods: {
    handlePre () {
      getPre({ type: 'system' }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.data = _.get(res, 'data', {})
          if (this.data.system_logo !== '') {
            this.logoUrl = this.data.system_logo_url
            this.fileList.push(
              {
                uid: '-1',
                name: '已上传企业LOGO',
                url: this.data.system_logo_url
              }
            )
          }
          if (this.data.app_download !== '') {
            this.downloadUrl = this.data.app_download_code_url
            this.downloadList.push(
              {
                uid: '-1',
                name: '已上传',
                url: this.data.app_download_code_url
              }
            )
          }
          this.form.setFieldsValue(this.data)
        }
      })
    },
    handleFileUpload (info, targetId) {
      if (info.file.status === 'removed') {
        this.data[targetId] = ''
      }
      const code = _.get(info.file, 'response.code')
      if (code && code !== 200) {
        this.$message.error(`${info.file.name} 图片上传失败`)
        return false
      }
      if (info.file.status === 'done') {
        const path = _.get(info.file, 'response.data.path')
        const picUrl = _.get(info.file, 'response.data.url')
        this.data[targetId] = path
        if (targetId === 'system_logo') {
          this.logoUrl = picUrl
        }
        if (targetId === 'app_download') {
          this.downloadUrl = picUrl
        }
        this.$message.success(`${info.file.name} 图片上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 图片上传失败`)
      }
    },
    handleChange (info) {
      this.handleFileUpload(info, 'system_logo')
      if (info.fileList.length > 1) {
        info.fileList = info.fileList.splice(0, 1)
      }
    },
    handleDownloadChange (info) {
      this.handleFileUpload(info, 'app_download')
      if (info.fileList.length > 1) {
        info.fileList = info.fileList.splice(0, 1)
      }
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = Object.assign(this.data, this.form.getFieldsValue())
          this.isSubmit = true
          saveConfig(data).then(res => {
            if (_.get(res, 'code') === 200) {
              this.handlePre()
              this.isEdit = false
              this.isSubmit = false
              notification.success({
                message: '更新成功',
                description: '保存成功'
              })
            } else {
              this.isSubmit = false
              notification.warning({
                message: '更新失败',
                description: '请稍后再试'
              })
            }
          })
        }
      })
    }
  }
}
</script>
